import {ApiProvider, PaginatedResult} from "@/providers/api-provider";
import axios from "axios";
import store from "@/stores/store";
import {Vue} from "vue-property-decorator";
import {ResourceProvider} from "@/interfaces/resource-provider";
import {Document} from "@/interfaces/document";

class DocumentApiProvider extends ApiProvider implements ResourceProvider {
  async addDocument(document: any) {
    const response = await this.uploadFile('/documents', document);
    return response;
  }

  async updateDocument(id: number, document: any) {
    const response = await this.put(`/documents/${id}`, document);
    return response;
  }

  async getMyDocuments(id: string | number, dataType: string) {
    const response = await this.get(`/documents/${dataType}/${id}`);
    return response.data;
  }

  async downloadPdf(url: string, filename: string) {
    await axios({
      url: `${process.env.VUE_APP_API_URL}/document/${url}`,
      method: "GET",
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${await store.getters["auth/getApiToken"]}`,
        "Access-Control-Allow-Origin": "*",
      }
    })
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        // Emit event "downloaded" used to close snackbar modal
        new Vue().$eventHub.$root.$emit("downloaded", link);
      })
      .catch((error) => {
        console.error('Erreur lors du téléchargement du PDF :', error);
      });
  }

  async getAll(params: URLSearchParams) {
    params.append("include", 'type, creator');
    const response = await this.get(`/documents?${params}`);
    return new PaginatedResult(response, Document);
  }

  exportAll(): void {
    // TODO
  }
}

export const documentApiProvider = new DocumentApiProvider();
